import React from "react";
import "./Skeleton.css";

const SkeletonLoadingSlider = () => {
  return (
    <div className="w-full group flex flex-row items-center h-[350px] md:h-[500px] overflow-hidden">
      <div className="skeleton mr-sm md:mr-md rounded-lg w-sCardWidth h-sCardHeight md:w-cardWidth md:h-cardHeight">
        <div
          className="card__header header__img w-sCardWidth h-sCardHeight md:w-cardWidth md:h-cardHeight skeleton rounded-lg"
          id="logo-img"
          alt=""
        ></div>
      </div>

      <div className="skeleton mr-md rounded-lg w-sCardWidth h-sCardHeight md:w-cardWidth md:h-cardHeight">
        <div
          className="card__header header__img w-sCardWidth h-sCardHeight md:w-cardWidth md:h-cardHeight skeleton rounded-lg"
          id="logo-img"
          alt=""
        ></div>
      </div>
      <div className="skeleton mr-md rounded-lg w-sCardWidth h-sCardHeight md:w-cardWidth md:h-cardHeight">
        <div
          className="card__header header__img w-sCardWidth h-sCardHeight md:w-cardWidth md:h-cardHeight skeleton rounded-lg"
          id="logo-img"
          alt=""
        ></div>
      </div>
      <div className="skeleton mr-md rounded-lg w-sCardWidth h-sCardHeight md:w-cardWidth md:h-cardHeight">
        <div
          className="card__header header__img w-sCardWidth h-sCardHeight md:w-cardWidth md:h-cardHeight skeleton rounded-lg"
          id="logo-img"
          alt=""
        ></div>
      </div>
      <div className="skeleton mr-md rounded-lg w-sCardWidth h-sCardHeight md:w-cardWidth md:h-cardHeight">
        <div
          className="card__header header__img w-sCardWidth h-sCardHeight md:w-cardWidth md:h-cardHeight skeleton rounded-lg"
          id="logo-img"
          alt=""
        ></div>
      </div>
      <div className="skeleton mr-md rounded-lg w-sCardWidth h-sCardHeight md:w-cardWidth md:h-cardHeight">
        <div
          className="card__header header__img w-sCardWidth h-sCardHeight md:w-cardWidth md:h-cardHeight skeleton rounded-lg"
          id="logo-img"
          alt=""
        ></div>
      </div>
      <div className="skeleton mr-md rounded-lg w-sCardWidth h-sCardHeight md:w-cardWidth md:h-cardHeight">
        <div
          className="card__header header__img w-sCardWidth h-sCardHeight md:w-cardWidth md:h-cardHeight skeleton rounded-lg"
          id="logo-img"
          alt=""
        ></div>
      </div>
    </div>
  );
};

export default SkeletonLoadingSlider;
